import React, { createContext, useContext, useState } from "react";
import axiosInstance, { handleApiError } from "../services/axiosService";
import { useFormContext } from "./FormContext";
import { createChecksum } from "../commonFunctions/fileFolderConfig";
import { useAppOrgContext } from "./AppOrgContext";

const AppUserContextApi = createContext();
const useAppUserContext = () => useContext(AppUserContextApi);
const AppUserContext = ({ children }) => {
  const { renderFieldsData, renderFieldsArray } = useFormContext();
  const { currentChecksum } = useAppOrgContext();
  const [appUserData, setAppUserData] = useState({});

  const getAppUserConfig = () => {
    return {
      ...appUserData,
      fields: createFormFieldArray()
    };
  };

  const createFormFieldArray = () => {
    const arrayCopy = [...renderFieldsArray];
    arrayCopy.sort((a, b) => a.y - b.y);

    //handle all outer field in form
    const newArray = arrayCopy.map((field) => {
      return renderFieldsData.current[field.i];
    });
    return newArray;
  };

  // const getCommunityUserConfig = () => {
  //   return createFormFieldArray();
  // };

  const handleSaveAppUser = async () => {
    try {
      const config = getAppUserConfig();
      const { message } = await axiosInstance.put(`/userConfig`, config);
      const newChecksum = createChecksum(config);
      currentChecksum.current = newChecksum;
      return {
        data: config,
        message
      };
    } catch (error) {
      handleApiError(error);
    }
  };
  // const handleSaveCommunityUser = async () => {
  //   try {
  //     const config = getCommunityUserConfig();
  //     const { message } = await axiosInstance.put(`/communityUserConfig`, config);
  //     const newChecksum = createChecksum(config);
  //     currentChecksum.current = newChecksum;
  //     return {
  //       data: config,
  //       message
  //     };
  //   } catch (error) {
  //     handleApiError(error);
  //   }
  // };
  return (
    <AppUserContextApi.Provider
      value={{
        handleSaveAppUser,
        getAppUserConfig,
        // getCommunityUserConfig,
        // handleSaveCommunityUser,
        createFormFieldArray,
        appUserData,
        setAppUserData
      }}
    >
      {children}
    </AppUserContextApi.Provider>
  );
};

export default AppUserContext;
export { useAppUserContext };
